/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.1.0
 * @since 1.1.0
 */
import { isValidElement } from 'react';

import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

function getCellValue(value: any) {
    return value && (
            isValidElement(value)
            || isNumber(value)
            || isString(value)
            || isArray(value)
        )
        ? value
        : undefined;
}

export default getCellValue;
